
import * as defaultImport from "@splunk/ui-utils/id";
export * from "@splunk/ui-utils/id";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
